import { render, staticRenderFns } from "./projectFurtherInfo.vue?vue&type=template&id=28a921bb&scoped=true&"
import script from "./projectFurtherInfo.vue?vue&type=script&lang=js&"
export * from "./projectFurtherInfo.vue?vue&type=script&lang=js&"
import style0 from "./projectFurtherInfo.vue?vue&type=style&index=0&id=28a921bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a921bb",
  null
  
)

export default component.exports